module.exports = __webpack_public_path__ + "media/components/assets/icons/star_rank/starHalf-ae1e17761c25c473c62ddaf7c5cf136c.svg";